<template>
  <footer class="site-footer">
    <p class="site-footer__links">
      <a href="/">{{ $t('footer_home') }}</a>
      · <a :href="privacyUrl">{{ $t('footer_privacy') }}</a>
      · <a :href="termsUrl">{{ $t('footer_terms') }}</a>
      · <a href="mailto:kontakt@plants4pets.pl">{{ $t('write_email') }}</a>
    </p>
    <p class="site-footer__copy">&copy; {{ year }} Plants4Pets</p>
  </footer>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'
import { mapState } from 'pinia'

export default {
  computed: {
    ...mapState(usePlantStore, ['lang']),
    year () {
      return new Date().getFullYear()
    },
    termsUrl () {
      return this.lang === 'en' ? '/en/regulamin' : '/regulamin'
    },
    privacyUrl () {
      return this.lang === 'en' ? '/en/privacy-policy' : '/polityka-prywatnosci'
    }
  }
}
</script>
